// #region Imports

/* Axios */
import axios from 'axios';

/* Telestream */
import { ConnectionService } from '@/services/connection.service';
import { FETCH_USER_INFO } from '@/utils/action-types';
import {
  SET_USER_AUTHENTICATION,
  SET_USER_NAME,
  SET_USER_ACCESS
} from '@/utils/mutation-types';

// #endregion Imports

export const user = {

  // #region State

  state: {
    name:               undefined,
    authenticationType: 'None',
    isAuthenticated:    false,
    groups:             [],
    hasAccessTo:        new Set()
  },

  // #endregion State

  // #region Mutations

  mutations: {

    [SET_USER_NAME](state, name) {
      state.name = name;
    },

    [SET_USER_AUTHENTICATION](state, { authenticationType, isAuthenticated, groups }) {
      state.authenticationType = authenticationType;
      state.isAuthenticated = isAuthenticated;
      state.groups = groups;
    },

    [SET_USER_ACCESS](state, access) {
      state.hasAccessTo = access;
    }

  },

  // #endregion Mutations

  // #region Actions

  actions: {

    async [FETCH_USER_INFO](context) {
      // Authentication
      const response = await axios.get(ConnectionService.getUrl('/user'));
      context.commit(SET_USER_NAME, response.data.name);
      document.title = response.data.name ? `GLIM (${response.data.name})` : 'GLIM'
      context.commit(
        SET_USER_AUTHENTICATION,
        {
          authenticationType: response.data.authentication,
          isAuthenticated:    response.data.isAuthenticated,
          groups:             response.data.groups
        }
      );

      // UI Access
      const connection = ConnectionService.getConnection('/ui-access');
      await connection.start();
      try {
        const allowedViews = new Set(await connection.invoke('GetAllowedViews'));
        context.commit(SET_USER_ACCESS, allowedViews);
      }
      finally {
        await connection.stop();
      }
    }

  }

  // #endregion Actions

}